import { D } from '@angular/cdk/keycodes';
import { ObjectUtil } from 'app/utils/object.util';

export class TurbineCockpit {

  performanceFacts: any;
  turbineInfo: any;
  meteo: any;
  events: any;
  electricParameters: any;
  temperatures: any;
  overallParameters: any;

  static setSignals(turbine: any, list: any) {
    const data = Object.assign({}, ...turbine.filteredData?.map(turbine => 
      ({[turbine.signalName]: turbine.dataValue?.stringValue || turbine.dataValue?.numericValue})));

    return new TurbineCockpit({
      performanceFacts: {
        dataAquisitionMax: ObjectUtil.getProperty(turbine, 'metaData.dataAquisitionMax.unixTimestamp', null),
        WTUR1_status: ObjectUtil.getProperty(turbine, 'data.WTUR1_status', null),
        WTUR1_kW_mag_f: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_mag_f', null),
        WTUR1_kW_theoretical: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_theoretical', null),
        ratedPower: ObjectUtil.getProperty(turbine, 'ratedPower', null),
        WTUR1_kW_loss: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_loss', null),
        WTUR1_per_loadFactor: ObjectUtil.getProperty(turbine, 'data.WTUR1_per_loadFactor', null),
        WTUR1_per_efficiency: ObjectUtil.getProperty(turbine, 'data.WTUR1_per_efficiency', null),
        // WNAC1_WdSpd_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_WdSpd_mag_f', null),
        LPHD1_PhyHealth_stVal: ObjectUtil.getProperty(turbine, 'data.LPHD1_PhyHealth_stVal', null),
        WTUR1_TurSt_actSt_stVal: ObjectUtil.getProperty(turbine, 'data.WTUR1_TurSt_actSt_stVal', null),
        // WTUR1_TurMaint_actSt_stVal: ObjectUtil.getProperty(turbine, 'data.WTUR1_TurMaint_actSt_stVal', null)
      },
      turbineInfo: {
        serialNav: ObjectUtil.getProperty(turbine, 'serialNav', null),
        serial: ObjectUtil.getProperty(turbine, 'serial', null),
        serialDisplay: ObjectUtil.getProperty(turbine, 'serialDisplay', null),
        type: ObjectUtil.getProperty(turbine, 'type', null),
        turbineManufacturer: ObjectUtil.getProperty(turbine, 'turbineManufacturer.name', null),
        ratedPower: ObjectUtil.getProperty(turbine, 'ratedPower', null),
        hubHeight: ObjectUtil.getProperty(turbine, 'hubHeight', null),
        diameter: ObjectUtil.getProperty(turbine, 'diameter', null),
        lat: ObjectUtil.getProperty(turbine, 'lat', null),
        lon: ObjectUtil.getProperty(turbine, 'lon', null),
        code: ObjectUtil.getProperty(turbine, 'code', null)
      },
      meteo: {
        weather: ObjectUtil.getProperty(turbine, 'park.currentWeather.icon', null),
        WNAC1_ExTmp_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_ExTmp_mag_f', null),
        WNAC1_WdSpd_c_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_WdSpd_c_mag_f', null),
        WNAC1_WdDir_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_WdDir_mag_f', null),
        WNAC1_Dir_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_Dir_mag_f', null)
      },
      events: {
        LPHD1_PhyHealth_stVal: ObjectUtil.getProperty(turbine, 'data.LPHD1_PhyHealth_stVal', null),
        WTUR1_TurSt_actSt_stVal: ObjectUtil.getProperty(turbine, 'data.WTUR1_TurSt_actSt_stVal', null),
        WTUR1_TurMaint_actSt_stVal: ObjectUtil.getProperty(turbine, 'data.WTUR1_TurMaint_actSt_stVal', null)
      },
      electricParameters: TurbineCockpit.setElectricalSignals(data, list),
      temperatures: TurbineCockpit.setTemperatureSignals(turbine, data, list),
      overallParameters: {
        WROT1_RotSpd_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_RotSpd_mag_f', null),
        WGEN1_Spd_mag_f: ObjectUtil.getProperty(turbine, 'data.WGEN1_Spd_mag_f', null),
        WROT1_PtAngValBl1_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_PtAngValBl1_mag_f', null),
        WROT1_PtAngValBl2_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_PtAngValBl2_mag_f', null),
        WROT1_PtAngValBl3_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_PtAngValBl3_mag_f', null),
        WROT1_PtHyPresBl1_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_PtHyPresBl1_mag_f', null),
        WROT1_PtHyPresBl2_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_PtHyPresBl2_mag_f', null),
        WROT1_PtHyPresBl3_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_PtHyPresBl3_mag_f', null),
        WTRM1_GbxOilPres_mag_f: ObjectUtil.getProperty(turbine, 'data.WTRM1_GbxOilPres_mag_f', null),
        WYAW1_CabWup_mag_f: ObjectUtil.getProperty(turbine, 'data.WYAW1_CabWup_mag_f', null),
        WTRM1_BrkHyPres_mag_f: ObjectUtil.getProperty(turbine, 'data.WTRM1_BrkHyPres_mag_f', null),
        WYAW1_BrkPres_mag_f: ObjectUtil.getProperty(turbine, 'data.WYAW1_BrkPres_mag_f', null),
        WROT1_PtAngValAvg_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_PtAngValAvg_mag_f', null),
        WROT1_PtHyPresAvg_mag_f: ObjectUtil.getProperty(turbine, 'data.WROT1_PtHyPresAvg_mag_f', null)
      }
    });
  }

  static setElectricalSignals(data, list) {
    const notNullableData = Object.entries(data).reduce((acc, [key, value]) => (value === null ? acc : (acc[key] = value, acc)), {})

    // electrical
    const filteredKeys = Object.keys(notNullableData)
      .filter(key => list?.signalsList
        .filter(signal => signal.signalGroupType === 'electrical')
        .map(signal => signal.name).includes(key)
      );
    const electricParameters = Object.assign({}, ...filteredKeys.map(key => {
      const signal = list?.signalsList.find(item => item.name === key);
      return { 
        [key]: {
          value: notNullableData[key],
          unit: signal.unit === '-' ? '' : signal.unit
        }
      }
    }));
    return electricParameters;
  }

  static setTemperatureSignals(turbine, data, list) {
    //temperature
    const parkData = Object.assign({}, ...turbine.park.filteredData?.map(signal => ({[signal.signalName]: signal.dataValue})))
    const filteredTempKeys = Object.keys(data).filter(key => list?.tempSignalsList.map(signal => signal.name).includes(key));
    const filteredTempKeysPark = Object.keys(parkData).filter(signal => list?.tempSignalsList.map(item => item.name).includes(signal));
    const temperatures = Object.assign({}, ...[...new Set([...filteredTempKeys, ...filteredTempKeysPark])].map(key => {
      const signal = list?.tempSignalsList.find(item => item.name === key);
      return { 
        [key]: {
          turbine: data[key],
          park: parkData[key],
          unit: signal.unit === '-' ? '' : signal.unit
        }
      }
    }));
    return temperatures;
  }

  constructor(init: Partial<TurbineCockpit>) {
    Object.assign(this, init);
  }

}
